module.exports = __webpack_public_path__ + "img/099-albania.4b188ee0.svg";